import { ProductTokens } from '../types'
import { colors, SevenNewsPalette } from './colors'

export const sevennews: ProductTokens<SevenNewsPalette> = {
    colors,
}
